(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[579],{

/***/ 57881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit-a-ticket",
      function () {
        return __webpack_require__(90270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18518);
/* harmony import */ var components_site_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51289);
/* harmony import */ var components_site_docsLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48257);




var SubmitATicketPage = function(props) {
    var navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Submit A Ticket"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_docsLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                navigationData: navigationData,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    px: "400",
                    maxWidth: "1150",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                as: "h1",
                                looksLike: "h2",
                                children: "SparkPost Support Has Moved"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: [
                                    "We have moved our support facility to",
                                    ' ',
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://app.sparkpost.com/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "app.sparkpost.com"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: [
                                    "As always, you can find quick answers using the search bar at the top of the page, check out specific topics on the menu at the left, and you’ll find our",
                                    ' ',
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://developer.sparkpost.com/api/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "API documentation here"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                    color: "blue",
                                    to: "https://app.sparkpost.com/dashboard?supportTicket=true&supportIssue=general_issue",
                                    external: true,
                                    children: "Login And Create a Ticket"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SubmitATicketPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,371,257,774,888,179], function() { return __webpack_exec__(57881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);